<template>
  <div v-if="!getIsAuthenticated" class="sidebar-links">
    <router-link to="/login" :class="{active: path === '/login'}">Login</router-link>
    <router-link to="/registration" :class="{active: path === '/registration'}">Register an account</router-link>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'getIsAuthenticated'
    ]),

    path() {
      return this.$route.path
    }
  }
}
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/SideNav/UnauthenticatedLinks.vue